import { render, staticRenderFns } from "./List2.vue?vue&type=template&id=28928268&scoped=true&"
import script from "./List2.vue?vue&type=script&lang=js&"
export * from "./List2.vue?vue&type=script&lang=js&"
import style0 from "./List2.vue?vue&type=style&index=0&id=28928268&prod&lang=scss&"
import style1 from "./List2.vue?vue&type=style&index=1&id=28928268&prod&lang=scss&scoped=true&"
import style2 from "./List2.vue?vue&type=style&index=2&id=28928268&prod&scoped=true&lang=css&"
import style3 from "./List2.vue?vue&type=style&index=3&id=28928268&prod&scoped=true&lang=css&"
import style4 from "./List2.vue?vue&type=style&index=4&id=28928268&prod&scoped=true&lang=css&"
import style5 from "./List2.vue?vue&type=style&index=5&id=28928268&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28928268",
  null
  
)

export default component.exports